import { StoreState } from "../../store";

const selector = (state: StoreState) => state.asset;

export const assetSelectors = {
  services: (state: StoreState) => selector(state).services,
};
